import { money0, timeAgo, eventText } from "@/lib/partners";

const Stat = ({ label, value, sub, gold }) => (
  <div className="bg-white border border-gray-200 p-5">
    <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500">{label}</p>
    <p className={`font-display text-2xl mt-1.5 ${gold ? "text-[#c19a6b]" : ""}`}>{value}</p>
    {sub && <p className="text-[11px] text-gray-400 mt-1">{sub}</p>}
  </div>
);

export const RealtorPerformance = ({ realtor }) => {
  const m = realtor.metrics;
  return (
    <div className="space-y-8" data-testid="realtor-performance">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Client Page Views" value={realtor.client_page_views} />
        <Stat label="Benefit Claims" value={m.activations} sub="activations completed" />
        <Stat label="Client Leads" value={m.leads} />
        <Stat label="Quotes" value={m.quotes} sub={`${m.invoiced} invoiced`} />
        <Stat label="Sales" value={m.sales} />
        <Stat label="Revenue Attributed" value={money0(m.revenue_cents)} gold />
        <Stat label="Est. ARK Gross Profit" value={money0(m.gross_profit_cents)} />
        <Stat label="Average Order Value" value={money0(m.aov_cents)} />
        <Stat label="Client Savings Generated" value={money0(m.client_savings_cents)} gold />
        <Stat label="Pieces Revived" value={m.pieces} />
        <Stat label="Conversion Rate" value={`${m.conversion_rate}%`} sub="sales / client page views" />
        <Stat label="Presentation Views" value={realtor.presentation_views} sub={realtor.last_viewed_at ? timeAgo(realtor.last_viewed_at) : "not yet viewed"} />
      </div>

      <div className="bg-black text-white p-6 sm:p-8" data-testid="realtor-impact-card">
        <p className="text-[11px] uppercase tracking-[0.22em] text-[#c19a6b] mb-5">Realtor-Facing Impact</p>
        <h3 className="font-display text-2xl sm:text-3xl mb-6">{realtor.first_name}'s ARK Private Client Impact</h3>
        <div className="grid grid-cols-3 gap-6">
          <div><p className="font-display text-3xl text-[#c19a6b]">{m.sales}</p><p className="text-[11px] uppercase tracking-[0.15em] text-white/50 mt-1">Clients Helped</p></div>
          <div><p className="font-display text-3xl text-[#c19a6b]">{m.pieces}</p><p className="text-[11px] uppercase tracking-[0.15em] text-white/50 mt-1">Pieces Revived</p></div>
          <div><p className="font-display text-3xl text-[#c19a6b]">{money0(m.client_savings_cents)}</p><p className="text-[11px] uppercase tracking-[0.15em] text-white/50 mt-1">Client Savings</p></div>
        </div>
      </div>

      <div>
        <h3 className="font-display text-xl mb-4">
          Activity timeline
          {m.last_activity_at && <span className="text-sm text-gray-400 font-sans ml-3">last activity {timeAgo(m.last_activity_at)}</span>}
        </h3>
        <div className="bg-white border border-gray-200 divide-y divide-gray-100" data-testid="realtor-timeline">
          {(realtor.timeline || []).length === 0 && <p className="px-5 py-8 text-sm text-gray-400">No activity yet.</p>}
          {(realtor.timeline || []).map((e) => (
            <div key={e.id} className="px-5 py-3.5 flex items-start justify-between gap-4">
              <p className="text-sm text-gray-700">{eventText(e)}</p>
              <span className="text-[11px] text-gray-400 whitespace-nowrap">{timeAgo(e.at)}</span>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-gray-400 mt-3">
          Client names are shown internally only — realtor-facing views never expose full customer details.
        </p>
      </div>
    </div>
  );
};
